export default __webpack_public_path__ + "static/media/bs.34972f16.jpg";